{
  "name": "quote-engine",
  "version": "3.0.0-beta1",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve -c=local",
    "start:dev": "ng serve -c=dev",
    "start:rc": "ng serve -c=rc",
    "start:ext-test": "ng serve -c=ext-test",
    "start:prod": "ng serve --configuration production",
    "build": "ng build && yarn",
    "build:prod": "ng build --configuration production",
    "build:dev": "ng build -c=dev",
    "build:rc": "ng build -c=rc",
    "build:ext-test": "ng build -c=ext-test",
    "test": "echo 'No unit tests configured'",
    "lint": "ng lint",
    "lint:styles": "stylelint \"src/**/*.scss\" --fix --color --formatter verbose",
    "check:all": "npm run lint:styles && ng lint --fix",
    "postinstall": "node scripts/fix-epi-components-maps.js"
  },
  "dependencies": {
    "@angular/animations": "^20.3.0",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@angular/platform-browser-dynamic": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@auth0/auth0-angular": "^2.2.0",
    "@datadog/browser-rum": "^6.24.1",
    "@datorama/akita": "^8.0.1",
    "@datorama/akita-ng-entity-service": "^8.0.0",
    "@floating-ui/dom": "^1.7.4",
    "@fulcrumui/css-utils": "^1.0.0-beta2",
    "@microsoft/applicationinsights-web": "^3.3.10",
    "@statsig/angular-bindings": "^3.30.0",
    "@statsig/client-core": "^3.30.0",
    "@statsig/js-client": "^3.30.0",
    "@types/auth0-js": "^9.21.6",
    "auth0-js": "^9.29.0",
    "epi-components": "^1.5.1",
    "js-levenshtein": "^1.1.6",
    "ng-recaptcha": "^13.2.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.4.1",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~20.3.0",
    "@angular-eslint/builder": "^20.3.0",
    "@angular-eslint/eslint-plugin": "^20.3.0",
    "@angular-eslint/eslint-plugin-template": "^20.3.0",
    "@angular-eslint/schematics": "^20.3.0",
    "@angular-eslint/template-parser": "^20.3.0",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^20.3.0",
    "@datorama/akita-ng-router-store": "^3.1.3",
    "@types/google.maps": "^3.58.1",
    "@types/js-levenshtein": "^1.1.3",
    "@types/node": "^22.0.0",
    "@typescript-eslint/eslint-plugin": "^8.48.0",
    "@typescript-eslint/eslint-plugin-tslint": "^7.0.2",
    "@typescript-eslint/parser": "^8.48.0",
    "eslint": "^9.39.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^61.4.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "husky": "^9.1.7",
    "npm-run-all": "^4.1.5",
    "sass": "^1.94.2",
    "stylelint": "^16.26.1",
    "stylelint-config-standard-scss": "^16.0.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.8.2"
  },
  "resolutions": {
    "@modelcontextprotocol/sdk": "^1.25.2",
    "semver": "^7.5.2",
    "tar": "^7.5.7"
  },
  "packageManager": "yarn@1.22.22+sha1.ac34549e6aa8e7ead463a7407e1c7390f61a6610"
}
